/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SearchAggregationBucket } from './searchAggregationBucket';

export interface SearchResultAggregation { 
    aggregated_entities: Array<string>;
    /**
     * Name of the aggregation bucket corresponding to aggregate operator in request
     */
    bucket_name: string;
    /**
     * Bodies of aggregation buckets
     */
    buckets: Array<SearchAggregationBucket>;
}